export default __webpack_public_path__ + "img/plin.473ca837.png";